export const errorUserNotFound = new Error("User not found");
export const errorInvalidCredentials = new Error("Invalid credentials");
export const errorConsentNotFound = new Error("Consent not found");